import { apiGet, apiPatch } from './client';
import type { TradePlace, TradePlaceBatchRequest } from '../types/TradePlace';

export function getTradePlaces(): Promise<TradePlace[]> {
  return apiGet<TradePlace[]>('/api/trade-places');
}

export function saveBatchTradePlaces(
  added: TradePlace[],
  modified: TradePlace[],
  deletedIds: number[],
): Promise<TradePlace[]> {
  return apiPatch<TradePlaceBatchRequest, TradePlace[]>(
    '/api/trade-places/batch',
    { added, modified, deleted: deletedIds },
  );
}
